import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import * as userActions from "../../../../../Redux/actions/userActions";
import { withRouter } from "react-router-dom";
import MainTemplate from "../../../mainTemplate";
import SearchUser from "../search";
import { errorContainer, loadingHtml } from "../../../../utils/functions";
import Modal from "../../../../utils/customModal";
import AddClientUser from "../add";

export class ScotiaUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: true,
      addUser: false,
      roles: false,
      userCode: 0,
      user: null,
      modal: { loading: false, show: false, content: null },
    };
  }

  findUserByCode = (userCode) => {
    this.setState({
      modal: { loading: true, show: true, content: loadingHtml() },
    });
    const {
      match: { params },
      actions: { getUserByCod },
    } = this.props;

    return getUserByCod(userCode, params.id, "PRO", params.countryCode)
      .then(() => {
        this.setState({
          search: false,
          addUser: true,
          modal: { loading: false, show: false, content: null },
        });
      })
      .catch(() => {
        // usuario no encontrado
        var buttons = {
          continueBtn: { text: "Continuar", action: this.closeModal },
        };
        var content = errorContainer(
          "Usuario no encontrado",
          `El usuario con el código ${userCode} no existe o no se encuentra ligado a esta institución`,
          buttons
        );
        this.setState({ modal: { loading: false, show: true, content } });
      });
  };

  closeModal = () => {
    if (!this.state.modal.loading) {
      this.setState({ modal: { show: false, content: null } });
    }
  };

  endStep = () => {
    const { clearUserByCode } = this.props.actions;
    clearUserByCode();
    this.setState({
      modal: { show: false, content: null },
    });

    this.closeStep();
  };

  closeStep = () => {
    this.props.history.push(
      `/bscadministrator/providers/${this.props.match.params.providerId}/${this.props.match.params.companyId}/profile`
    );
  };

  render() {
    const { addUser, search, userCode } = this.state;

    return (
      <MainTemplate>
        {search && <SearchUser findUserByCode={this.findUserByCode} />}
        {addUser && (
          <AddClientUser
            canEdit={true}
            userCode={userCode}
            endStep={this.endStep}
            closeStep={this.closeStep}
            nextStep={(user) =>
              this.setState({ addUser: false, roles: true, user: user })
            }
          />
        )}
        <Modal
          handleClose={() => this.closeModal()}
          show={this.state.modal.show}
          id="add-user-modal"
        >
          <div className="molda-setting-content">
            {this.state.modal.content}
          </div>
        </Modal>
      </MainTemplate>
    );
  }
}

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(userActions, dispatch),
  };
};

export default withRouter(connect(null, mapDispatch)(ScotiaUsers));
